var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmbedDocs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 435 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 415,
    height: 180,
    rx: 3,
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 60,
    width: 100,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 96,
    width: 125,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 96,
    width: 55,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 96,
    width: 64,
    height: 6,
    rx: 3,
    fill: "#7DC560"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 114,
    width: 260,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 132,
    width: 201,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 132,
    width: 51,
    height: 6,
    rx: 3,
    fill: "#E43A25"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 150,
    width: 260,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 168,
    width: 190,
    height: 6,
    rx: 3,
    fill: "#E9EBF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 435,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedDocs);
export default __webpack_public_path__ + "static/media/embed-docs.c1d921a2.svg";
export { ForwardRef as ReactComponent };